"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gauge = void 0;

var _counter = require("./counter");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Gauge =
/*#__PURE__*/
function (_Counter) {
  _inherits(Gauge, _Counter);

  function Gauge() {
    _classCallCheck(this, Gauge);

    return _possibleConstructorReturn(this, _getPrototypeOf(Gauge).apply(this, arguments));
  }

  _createClass(Gauge, [{
    key: "dec",
    value: function dec(labels) {
      var metric = this.get(labels);
      this.set(metric ? metric.value - 1 : 0, labels);
      return this;
    }
  }, {
    key: "sub",
    value: function sub(amount, labels) {
      var metric = this.get(labels);
      this.set(metric ? metric.value - amount : 0, labels);
      return this;
    }
  }]);

  return Gauge;
}(_counter.Counter);

exports.Gauge = Gauge;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9nYXVnZS50cyJdLCJuYW1lcyI6WyJHYXVnZSIsImxhYmVscyIsIm1ldHJpYyIsImdldCIsInNldCIsInZhbHVlIiwiYW1vdW50IiwiQ291bnRlciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQUVhQSxLOzs7Ozs7Ozs7Ozs7O3dCQUNQQyxNLEVBQXVCO0FBQ3pCLFVBQU1DLE1BQU0sR0FBRyxLQUFLQyxHQUFMLENBQVNGLE1BQVQsQ0FBZjtBQUNBLFdBQUtHLEdBQUwsQ0FBU0YsTUFBTSxHQUFHQSxNQUFNLENBQUNHLEtBQVAsR0FBZSxDQUFsQixHQUFzQixDQUFyQyxFQUF3Q0osTUFBeEM7QUFDQSxhQUFPLElBQVA7QUFDRDs7O3dCQUVHSyxNLEVBQWdCTCxNLEVBQXVCO0FBQ3pDLFVBQU1DLE1BQU0sR0FBRyxLQUFLQyxHQUFMLENBQVNGLE1BQVQsQ0FBZjtBQUNBLFdBQUtHLEdBQUwsQ0FBU0YsTUFBTSxHQUFHQSxNQUFNLENBQUNHLEtBQVAsR0FBZUMsTUFBbEIsR0FBMkIsQ0FBMUMsRUFBNkNMLE1BQTdDO0FBQ0EsYUFBTyxJQUFQO0FBQ0Q7Ozs7RUFYd0JNLGdCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTGFiZWxzIH0gZnJvbSAnLi90eXBlcyc7XG5pbXBvcnQgeyBDb3VudGVyIH0gZnJvbSAnLi9jb3VudGVyJztcblxuZXhwb3J0IGNsYXNzIEdhdWdlIGV4dGVuZHMgQ291bnRlciB7XG4gIGRlYyhsYWJlbHM/OiBMYWJlbHMpOiB0aGlzIHtcbiAgICBjb25zdCBtZXRyaWMgPSB0aGlzLmdldChsYWJlbHMpO1xuICAgIHRoaXMuc2V0KG1ldHJpYyA/IG1ldHJpYy52YWx1ZSAtIDEgOiAwLCBsYWJlbHMpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgc3ViKGFtb3VudDogbnVtYmVyLCBsYWJlbHM/OiBMYWJlbHMpOiB0aGlzIHtcbiAgICBjb25zdCBtZXRyaWMgPSB0aGlzLmdldChsYWJlbHMpO1xuICAgIHRoaXMuc2V0KG1ldHJpYyA/IG1ldHJpYy52YWx1ZSAtIGFtb3VudCA6IDAsIGxhYmVscyk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cbn1cbiJdfQ==